// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3dkEm","approved":"Status_approved__2cd67","rejected":"Status_rejected__LiTem","expired":"Status_expired__1YbkB","label":"Status_label__2gaaL"};